import { useIsMSquaredBranding } from "../branding/hooks";

const RETURN_URL_KEY = "app-return-url";

const isValidSameOriginUrl = (url: string) => {
  try {
    return new URL(url).origin === window.location.origin;
  } catch {
    return false;
  }
};

export const storeReturnUrl = () => {
  sessionStorage.setItem(RETURN_URL_KEY, window.location.href);
};

const readReturnUrl = () => {
  const stored = sessionStorage.getItem(RETURN_URL_KEY);
  return stored && isValidSameOriginUrl(stored) ? stored : null;
};

export const useReturnToAppLabel = () =>
  useIsMSquaredBranding() ? "Back to Chat" : "Return to App";

export const getReturnToAppHandler = () => {
  const returnUrl = readReturnUrl();
  if (!returnUrl) return undefined;

  return () => {
    sessionStorage.removeItem(RETURN_URL_KEY);
    window.location.href = returnUrl;
  };
};
